import "./Podcasts.css";

import React, { useState } from "react";

import AudioPlayer from "../../components/AudioPlayer/AudioPlayer";
import type { IPodcast } from "../../types/podcastType";
import { epochToDateString } from "../../helper";
import { usePodcast } from "../../hooks/APIs/usePodcast";

const SKELETON_ROWS = 8;

function Podcasts() {
  const { podcasts, isLoading } = usePodcast();

  const [playingPodcast, setPlayingPodcast] = useState<IPodcast | null>(null);
  const [showProPodcastView, setShowProPodcastView] = useState(false);

  const playBtnClick = (podcast: IPodcast) => {
    if (!podcast.url || podcast.url.trim() === "") {
      setShowProPodcastView(true);
      return;
    }
    if (playingPodcast?.id === podcast.id) {
      setPlayingPodcast(null);
    } else {
      setPlayingPodcast(podcast);
    }
  };

  return (
    <div className="main-container-podcast">
      <div className="main-div-podcast">
        <div className="img-podcasts">
          <img
            src={
              "https://image.simplecastcdn.com/images/28cf584b-655b-43e4-907e-5118090f703f/9af6571a-6ca2-479b-883d-f5bdbd5f0e96/80x80/eurointelligence-podcast@2x.jpg"
            }
            alt="podcast"
            className="podcastsing"
          />
          <div className="playlist-info">
            <div className="playlist-title">EuroIntelligence Podcast</div>
            {isLoading ? (
              <div className="skeleton skeleton-text skeleton-description" />
            ) : (
              <div>{podcasts?.[0]?.description ?? ""}</div>
            )}
          </div>
        </div>

        <div className="list-podcasts">
          <div className="titleHeader">
            <span className="play-button-img">#</span>
            <span className="podcast-name">Title</span>
            <span className="podcast-heads">Date</span>
            <span className="podcast-heads">Views</span>
            <span className="podcast-time">Duration</span>
          </div>
          <div className="podcasts-playlists">
            {isLoading &&
              Array.from({ length: SKELETON_ROWS }, (_, i) => (
                <div key={`skeleton-${i}`} className="podcast-details" aria-hidden="true">
                  <span className="play-button-img">
                    <span className="skeleton skeleton-circle" />
                  </span>
                  <span className="podcast-name">
                    <span className="skeleton skeleton-text skeleton-title" />
                  </span>
                  <span className="podcast-heads">
                    <span className="skeleton skeleton-text skeleton-short" />
                  </span>
                  <span className="podcast-heads">
                    <span className="skeleton skeleton-text skeleton-tiny" />
                  </span>
                  <span className="podcast-time">
                    <span className="skeleton skeleton-text skeleton-tiny" />
                  </span>
                </div>
              ))}
            {podcasts.map((podcast) => {
              const isPlaying = podcast.id === playingPodcast?.id;
              return (
                <div key={podcast.id} className="podcast-details">
                  <span
                    className="play-button-img"
                    onClick={() => playBtnClick(podcast)}
                  >
                    <img
                      height={30}
                      width={30}
                      src={
                        isPlaying ? "./assets/pause.svg" : "./assets/play.svg"
                      }
                      alt="Play"
                    />
                  </span>
                  <span className="podcast-name">{podcast.title}</span>
                  <span className="podcast-heads">
                    {epochToDateString(
                      new Date(podcast.createdAt).getTime() / 1000,
                    )}
                  </span>
                  <span className="podcast-heads">{podcast.viewCount}</span>
                  <span className="podcast-time">{podcast.duration}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {!!playingPodcast && <AudioPlayer url={playingPodcast.url} />}

      {showProPodcastView && (
        <div
          className="pro-podcast-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="pro-podcast-title"
        >
          <div
            className="pro-podcast-overlay__backdrop"
            onClick={() => setShowProPodcastView(false)}
            aria-hidden="true"
          />
          <div className="pro-podcast-overlay__box">
            <button
              type="button"
              className="pro-podcast-overlay__close-btn"
              onClick={() => setShowProPodcastView(false)}
              aria-label="Close"
            >
              ×
            </button>
            <div className="pro-podcast-view">
              <p id="pro-podcast-title" className="pro-podcast-view__message">
                This is a paid podcast. Please upgrade your subscription to listen to this podcast.
              </p>
              <button
                type="button"
                className="pro-podcast-view__close"
                onClick={() => setShowProPodcastView(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Podcasts;
